// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3OMrZ","rootSuccess":"CompleteLink_rootSuccess__2sEhx","rootFailure":"CompleteLink_rootFailure__1wNDe","isDisabled":"CompleteLink_isDisabled__1lQRz"};